import httpClient, { createHttpClient } from './httpClient';
import {Apis} from "./Apis";
//import Raven from 'raven-js';
//import store from '../store/index';

//https://laravel-news.com/building-flexible-axios-clients
const getClient = (baseUrl = null) => {

  const options = {
    baseURL: baseUrl
  };

  const client = createHttpClient(options.baseURL || null);

  // Add a response interceptor
  client.interceptors.response.use(
    response => response,
    (error) => {

      let errorMessage = "";

      if (!error.response) {
        // network error
        errorMessage = 'Verifique su conexion a internet';
      } else {

        if (error.response.status >= 500) {
          //sentry por observavility porpuses
          //Raven.captureException(error);
        }

        errorMessage = error.response.data.message;
      }

      return Promise.reject(errorMessage);
    },
  );

  return client;
};

class ApiClient {
  constructor(baseUrl = null) {
    this.client = getClient(baseUrl);
  }

  get(url, conf = {}) {
    return this.client.get(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  delete(url, conf = {}) {
    return this.client.delete(url, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  post(url, data = {}, conf = {}) {
    return this.client.post(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  put(url, data = {}, conf = {}) {
    return this.client.put(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }

  patch(url, data = {}, conf = {}) {
    return this.client.patch(url, data, conf)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error));
  }
}

export {ApiClient};

const apiClient = new ApiClient(process.env.REACT_APP_BASE_IP);
//const apiClientPC = new ApiClient(process.env.REACT_APP_BASE_POINTCORE);
//const apiClientSor = new ApiClient(process.env.REACTREACT_APP_BASE_SOR_APP_BASE_SOR);

export const ApiServicev2 = {

  couponSummary(params = {}) {
    const path = '/coupons/summary';
    return apiClient.get(path, {params: params});
  },

  getPrinters() {
    const path = '/printers/state-report';
    return apiClient.get(Apis.PRINTER + path);
  },
};

export const CouponServicev2 = {

  async getCouponPrintHistory(params = {}) {
    const path = '/coupon-print-job/last';
    const res = await httpClient.get(Apis.PC + path, {params: params});
    return res.data;
  },

  async getCouponTypeActive(salaId) {
    const path = '/coupon-type/active';
    const res = await httpClient.get(Apis.PC + path, {});
    return res.data;
  },

  async buildAndPrint(couponPrintJobForm) {
    const path = '/coupon-print-job/build-n-print';
    const res = await httpClient.post(Apis.PC + path, couponPrintJobForm);
    return res.data;
  },

  async checkState(couponPrintJobId) {
    const path = `/coupon-print-job/${couponPrintJobId}/state/v2`;
    const res = await httpClient.get(Apis.PC + path);
    return res.data;
  },

  async retryCouponPrintJob(couponPrintJobId) {
    const path = `/coupon-print-job/${couponPrintJobId}/retry`;
    const res = await httpClient.post(Apis.PC + path);
    return res.data;
  },
  async validateCoupon(couponId, params) {
    const path = '/coupon/' + couponId + '/validate-dto';
    const res = await httpClient.get(Apis.PC + path, {params: params});
    return res.data;
  },
};

export const SorteoService = {
  async getSorteos(params = {}) {
    const path = '/sorteos';
    const res = await httpClient.get(Apis.SORTEOS + path, {params: params});
    return res.data;
  },

  async saveSorteoWinner(params) {
    const path = '/sorteo-winner';
    const res = await httpClient.post(Apis.SORTEOS + path, params);
    return res.data;
  },

  async deleteWinner(sorteoWinnerId) {
    const path = '/sorteo-winner/' + sorteoWinnerId;
    const res = await httpClient.delete(Apis.SORTEOS + path);
    return res.data;
  },
};

export const SwapService ={

  async saveSwapPost(params) {
    const path = `/redeems`;
    const res = await httpClient.post(Apis.PC + path, params);
    return res.data;
  },

  async checkQuantityRedeems(params) {
    const path = `/redeems/by-customer`;
    const res = await httpClient.get(Apis.PC + path, params);
    return res.data;
  },
}
